import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleGlobalLoader } from "../../../store/actions/session";
import * as actions from "../../../store/actions";
import { DateTime } from "luxon";
import _ from "lodash";
import { get as _get } from "lodash";

import * as ODCalls from "../../../store/calls/indicativeOptionData";
import { addErrorAlert } from "../../../store/calls/alertLoadingDispatch";
import { pullProjects } from "../../../store/calls";
import { withRouter } from "react-router-dom";
import formatters from "../../../utils/forms/formatters";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import Input from "../../theme/forms/Input";

class ProjectsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isopenFilter: false,
      filterSelected: 0,
      textFilter: 0,
      query: "",
      currentData: [],
      dateSelected: DateTime.now().toISODate(),
      dateChange: DateTime.now().toISODate(),
      addressChange: '',
      selectedAddress: null,
      userChange: '',
      selectedUser: null,
      filterMethod: 'date',
      isFetched: false,
      isLoading: true,

    };
  }

  componentDidMount() {
    const currentDate = this.props.location.search.split("date=")[1]
      ? this.props.location.search.split("date=")[1]
      : DateTime.now().toISODate();
    this.setState({
      dateSelected: currentDate,
      dateChange: currentDate,
      isFetched: false,
      isLoading: true,
    });
    this.fetchData(currentDate);
    toggleGlobalLoader(true);
    Promise.allSettled([
      ODCalls.getAssetTypes(),
      ODCalls.getBusinessTypes(),
      ODCalls.getAvailableImprovements(),
    ])
      .catch(() => {
        addErrorAlert("Failed to load all initial data.", 10 * 1000);
      })
      .finally(() => {
        toggleGlobalLoader(false);
      });
  }


  fetchData = () => {

    let params = {};
    let stateUpdatePreLoad = { isFetched: false, isLoading: true };
    let stateUpdatePostLoad = {};
    if (this.state.filterMethod === 'date') {
       params['date'] = this.state.dateChange;
       stateUpdatePostLoad = {dateSelected: this.state.dateChange}
    } else if (this.state.filterMethod === 'address') {
      params['address'] = this.state.addressChange;
      stateUpdatePostLoad = {selectedAddress: this.state.addressChange}
    } else if (this.state.filterMethod === 'user') {
       params['user_string'] = this.state.userChange;
       stateUpdatePostLoad = {selectedUser: this.state.userChange}
    }

    this.setState(stateUpdatePreLoad);

    toggleGlobalLoader(true);
    pullProjects(params).then((res) => {
      this.setState({
        data: res,
        isFetched: true,
        isLoading: false,
        currentData: res,
        ...stateUpdatePostLoad
      });
    }).finally(() => {
      toggleGlobalLoader(false);
    })
  };


  getImprovementName = (id) => {
    const { improvements } = this.props.optionData;
    if (!improvements || improvements.length == 0) return "";
    const improvement = improvements.find((i) => i.id == id);
    return improvement ? improvement.name : "";
  };


  getBusinessTypeName = (id) => {
    const { businessTypes } = this.props.optionData;
    if (!businessTypes || businessTypes.length == 0) return "";
    const businessType = businessTypes.find((i) => i.id == id);
    return businessType ? businessType.name : "";
  };


  onOpenProject = (project, estimategroup_id) => {
    this.props.setFocusedProject(project.id);

    const formFlowComputed = {
      address: project.data.address,
      programs: project.data.programs,
    };

    this.props.clearFormFlow();
    this.props.updateInputs({...project.data, id: project.id});
    this.props.updateComputed(formFlowComputed);
    this.props.updateCurrentStep(1);

    if (estimategroup_id) {
      window.location = `/share-estimate/?g=${estimategroup_id}`
    }
    this.props.history.push({
      pathname: "/project",
    });
  };


  onChangeDate = (e) => {
    this.setState({ dateChange: e.target.value, isFetched: false });
  };


  onChangeAddress = (e) => {
    this.setState({ addressChange: e.target.value, isFetched: false });
  };

  onChangeUser = (e) => {
    this.setState({ userChange: e.target.value, isFetched: false });
  };

  onChangeFilterMethod = (e) => {
    this.setState({ filterMethod: e.target.value, isFetched: false });
  };


  onSelectPastEstimateGroup = (project, id) => {
      this.onOpenProject(project, id);
  };


  renderFilter = () => {
    const {dateChange, addressChange, userChange, filterMethod} = this.state;
    return (
        <div className="field has-addons">
          <div className={'control'}>
            <select
                value={filterMethod}
                onChange={this.onChangeFilterMethod}
                className={'input'}
                style={{width: '10em'}}
            >
              <option value={'date'}>Date</option>
              <option value={'address'}>Address</option>
              <option value={'user'}>User</option>
            </select>
          </div>
          {filterMethod === 'date' &&
              <div className="control">
                <input
                    className="input"
                    style={{width: '10em'}}
                    type="date"
                    value={dateChange}
                    onChange={this.onChangeDate}
                    max={DateTime.now().toISODate()}
                    min="2021-05-01" // start of operations of PACEFI
                />
              </div>
          }
          {filterMethod === 'address' &&
              <div className="control">
                <input
                    className="input"
                    style={{width: '10em'}}
                    type="text"
                    value={addressChange}
                    onChange={this.onChangeAddress}
                />
              </div>
          }
          {filterMethod === 'user' &&
              <div className="control">
                <input
                    className="input"
                    style={{width: '10em'}}
                    type="text"
                    value={userChange}
                    onChange={this.onChangeUser}
                />
              </div>
          }
          <div className="control">
            <button
                className="button is-info"
                onClick={this.fetchData}
                disabled={this.isFetchDisabled()}
            >
              Find projects
            </button>
          </div>
        </div>
    );
  };



  isFetchDisabled = () => {
    const { isFetched, isLoading} = this.state;

     return isFetched || isLoading;
  }



  renderItem = (project) => {
    if (!project) return <div />;
    const { modified, data, estimate_groups, user } = project;
    const { address, project_name, improvements } = data || {};

    if (!address) return <div />;
    const modifiedFormatted = DateTime.fromJSDate(new Date(modified)).toFormat(
      "D"
    );
    return (
      <div
        key={project.id + "key-projects"}
        className="box box-my-project is-flex is-flex-direction-column flex-start"
      >
        <div className="is-flex is-justify-content-space-between ">
          <div />
          <span>{modifiedFormatted}</span>
        </div>

        <h3>
          <b>{project_name}</b>
        </h3>
        <p>{address && address.formatted_address}</p>
        <p className="user-title">
          <b>
            Created by: {user?.first_name} {user?.last_name}{" "}
          </b>
        </p>
        <hr />
        <div className="is-flex is-justify-content-space-between">
          <div className="">
            {improvements &&
              improvements.length > 0 &&
              improvements.map((impr) => (
                <h6 className="title is-6 mb-0 mt-2  improvements-items user-title">
                  <span>{this.getImprovementName(impr.id)}:</span>
                  <span>{impr.value ? `$ ${impr.value}` : ` -`}</span>
                </h6>
              ))}
          </div>
          <div className="buttons">
            {!estimate_groups.length &&

            <button
                onClick={() => null}
                className="button is-danger m-0 mr-3 disabled"
            >
              Project Not Yet Complete
            </button>
            }
            {!!estimate_groups.length &&
            <>
              <button
                  onClick={() => this.onOpenProject(project, estimate_groups?.[0]?.id)}
                  className="button is-link m-0 mr-3"
              >
                Get Today's Estimates
              </button>
              <Input
                  type={"select"}
                  options={estimate_groups.map(d => (
                      {
                        value: d.id,
                        display: DateTime.fromISO(d.created).toFormat("ff")
                      }
                  ))
                  }
                  onChange={(id) => {
                    this.onSelectPastEstimateGroup(project, id)
                  }}
              />
            </>
            }
          </div>
        </div>
      </div>
    );
  };



  render() {
    const { currentData, isFetched, isLoading, dateSelected } = this.state;
    return (
      <AdminWrapper>
        <div className="container px-2">
          <h1 className="is-size-4 has-text-primary mt-4  mb-4 has-text-weight-semibold  default-title ">
            NEW PROJECTS
          </h1>
          <div className="is-flex is-justify-content-flex-end my-6">
            {this.renderFilter()}
          </div>
          {currentData && currentData.length > 0 ? (
            currentData.map((project) => this.renderItem(project))
          ) : isLoading ? (
            <p>Loading...</p>
          ) : (
            <p>0 Results for {this.state.filterMethod === 'date' ?
                DateTime.fromISO(dateSelected).toFormat("DD") :
                this.state.addressSelected
            }</p>
          )}
        </div>
      </AdminWrapper>
    );
  }
}


const mapStateToProps = (state) => ({
  optionData: state.indicativeOptionData,
  tokenData: state.user.decodedTokenData,
});



const mapDispatchToProps = (dispatch) => ({
  //focused project is alwasy ust the id
  setFocusedProject: (data) =>
    dispatch(actions.projectLeads.setFocusedProject(data)),
  updateInfoFeedDisplay: (data) =>
    dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
  clearInfoFeedDisplay: (data) =>
    dispatch(actions.infoFeed.clearInfoFeedDisplay(data)),

  updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
  updateComputed: (data) =>
    dispatch(actions.formFlow.updateFormFlowComputed(data)),
  updateCurrentStep: (data) =>
    dispatch(actions.formFlow.setFormFlowCurrStep(data)),
  clearFormFlow: (data) => dispatch(actions.formFlow.clearFormFlow(data)),
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjectsScreen));
